

import React, { useEffect, useState } from "react";
import SalesReport from "./SalesReport";
import SelectItems from "../components/helpers/SelectItems";
import StockExpiryReport from "./StockExpiryReport";
import RestockingReport from "./RestockingReport";
import ProfitLossReport from "./ProfitLossReport";

const Reports = () => {
  const [selectedOption, setSelectedOption] = useState([]);
  const [page, setPage] = useState(<SelectItems />);

  useEffect(() => {
    if (selectedOption !== 0) {
      switch (selectedOption) {
        case "0":
          setPage(<SelectItems />);
          break;
        case "1":
          setPage(<SalesReport />);
          break;
        case "2":
          setPage(<StockExpiryReport />);
          break;
        case "3":
          setPage(<RestockingReport />);
          break;
        case "4":
          setPage(<ProfitLossReport />);
          break;
       
      }
    }
  }, [selectedOption]);

  return (
    <div>
      <div className="form-group row">
        <div className="col-md-12">
          <select
            className="form-control-sm"
            id="reports"
            onChange={(e) => setSelectedOption(e.target.value)}
          >
            <option disabled selected value="0">
              Select report
            </option>
            <option value="1">Sales Report</option>           
            <option value="2">Stock Expiry Report</option>           
            <option value="3">Restocking Report</option>           
            <option value="4">Profit Loss Report</option>           
          </select>
        </div>
      </div>
      <div>{page}</div>
    </div>
  );
};


export default Reports